import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { noop } from "lodash";

const SortableBookmarkContext = createContext({
  bookmark: {},
  space: {},
  isFolderDropdownOpen: false,
  onFolderDropdownToggle: noop,
});
SortableBookmarkContext.displayName = "SortableBookmarkContext";

export const useSortableBookmarkContext = () =>
  useContext(SortableBookmarkContext);

export const SortableBookmark = ({ bookmark, space, children }) => {
  const [isFolderDropdownOpen, setIsFolderDropdownOpen] = useState(false);

  return (
    <SortableBookmarkContext.Provider
      value={{
        bookmark,
        space,
        isFolderDropdownOpen,
        setIsFolderDropdownOpen,
      }}
    >
      {children}
    </SortableBookmarkContext.Provider>
  );
};

SortableBookmark.propTypes = {
  bookmark: PropTypes.object.isRequired,
  space: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};
